import { GenericElementEvent } from '../../../../../services/event/event/generic-element-event';

export class GenericGridDestroyEvent extends GenericElementEvent {
    
}
